export enum PinResourceType {
  Task = 'TASK',
  Project = 'PROJECT',
  SpaceTab = 'SPACE_TAB',
  Chat = 'CHAT',
  Files = 'FILES',
  SavedView = 'SAVED_VIEW',
}

export enum PinScopeType {
  Project = 'PROJECT',
  Account = 'ACCOUNT',
  ProjectConversation = 'PROJECT_CONVERSATION',
  Task = 'TASK',
  Document = 'DOCUMENT',
  StatusUpdate = 'STATUS_UPDATE',
}

export interface CustomerPin {
  customerResourcePinnedMappingId: string;
  caption: string;
  projectId?: number;
  accountId?: number;

  resourceType: PinResourceType;
  resourceId: number;

  scopeId?: number;
  scopeType: PinScopeType;

  createdAt: number;
  updatedAt?: number;
  createdBy: number;
  updatedBy?: number;
  deleted?: boolean;
}

export type Spotlight = CustomerPin;
